import createAvailableModulesHook from "./createAvailableModulesHook";

export default createAvailableModulesHook((s) => s.courseStudyModules);
